import { OptionsFilterEnum } from "enums/OptionsFilterEnum"
import { IFilterOrder } from "interfaces/IFilterOrder"

export const filterOrderData: Array<IFilterOrder> = [
  {
    value: OptionsFilterEnum.query,
    label: "Id orden o SG",
  },
  {
    value: OptionsFilterEnum["custom.customer.name"],
    label: "Nombre cliente",
  },
  {
    value: OptionsFilterEnum["custom.customer.id"],
    label: "RUT",
  },
  {
    value: OptionsFilterEnum["source.name"],
    label: "Source",
  },
  {
    value: OptionsFilterEnum["source.items.custom.series"],
    label: "Nro de serie",
  },
  {
    value: OptionsFilterEnum["custom.contenedorPadre"],
    label: "Contenedor Padre",
  },
]
